/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import {ScorecardTable} from '../styles';
import {Utils} from '../../../../utils/api';
import {GoChevronDown, GoChevronUp} from 'react-icons/go';
import {SelectPlayerColumn} from '../../../../components';
import {Oval} from '../../../players/styles';
import {ColumnContainerSummary, ArrowHolderSummary} from '../../../../components/Table/styles';
import {default as TableContainer} from '../tableContainer';

export default ({dataTableContent}: {dataTableContent: Array<any>}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const UTILS = new Utils();
  useEffect(() => {
    const newExams = dataTableContent?.filter(item => {
      if (item?.fatigue?.alert) {
        return item;
      } else {
        return false;
      }
    });
    useTable(newExams);
  }, [dataTableContent]);
  function changeTable(e) {
    useTable([...e]);
  }

  function toggleSortString(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }

  const SortingTableHead = ({
    title,
    attr,
    location,
    sortFunction,
  }: {
    title?: string;
    attr?: any;
    location?: any;
    sortFunction: Function;
  }) => {
    return (
      <th onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </th>
    );
  };
  function playerStatus(status: string) {
    switch (status) {
      case 'Watch':
        return <Oval size={'9'} color={'yellow'} margin={'0px 3px 0px 0px'} />;

      case 'Warning':
        return <Oval size={'9'} color={'red'} margin={'0px 3px 0px 0px'} />;

      case 'Medical':
        return <Oval size={'9'} color={'blue'} margin={'0px 3px 0px 0px'} />;

      default:
        return;
    }
  }

  return (
    <TableContainer title={'Fatigue'} numberOfPlayers={table.length} subTitle="Any Fatigue Alert: watch, warning or medical">
      <ScorecardTable>
        <thead>
          <tr>
            <SortingTableHead title="Players" attr="firstName" location={['player', 'firstName']} sortFunction={toggleSortString} />
            <SortingTableHead title="Alert" attr="alert" location={['fatigue', 'alert']} sortFunction={toggleSortString} />
            <SortingTableHead title="Test" attr="test" location={['fatigue', 'test']} sortFunction={toggleSortString} />
          </tr>
        </thead>
        <tbody>
          {table?.length > 0 ? (
            table?.map((item, index) => {
              return (
                <tr key={index}>
                  <SelectPlayerColumn player={item?.player} />
                  <td>
                    {playerStatus(item?.fatigue?.alert)}
                    {(item?.fatigue?.alert !== undefined || item?.fatigue?.alert !== null) ? item?.fatigue?.alert : '-'}
                  </td>
                  <td>{(item?.fatigue?.test !== undefined || item?.fatigue?.test !== null) ? item?.fatigue?.test : '-'}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={3}>No Data</td>
            </tr>
          )}
        </tbody>
      </ScorecardTable>
    </TableContainer>
  );
};
